module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1261.cc5a33e5.png";